var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
'x': '0px',
'y': '0px',
'width': '48px',
'height': '48px',
'viewBox': '0 0 48 48',
'enable-background': 'new 0 0 48 48',
'xmlSpace': 'preserve',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <polygon fill=\"#FF5722\" points=\"40,45 8,45 8,3 30,3 40,13 \"/> <polygon fill=\"#FBE9E7\" points=\"38.5,14 29,14 29,4.5 \"/> <path fill=\"none\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M34,31.5c0-4.2-22.8,4.1-18.5,6.4 C19,39.8,27.4,19,23.2,19c-4.1,0,2.6,13.6,8.8,13.6C33.5,32.6,34,32.3,34,31.5z\"/> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/pdf-file.svg